import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OrganizzazioniService} from "../../../_services/organizzazioni.service";
import {Spedizione} from "../../../_models/Spedizione";
import {SpedizioniService} from "../../../_services/spedizioni.service";
import {SearchResult} from "../../../_models/SearchResult";
import {SaveMessage} from "../../../_helpers/save-message";
import {AuthenticationService} from "../../../_services/authentication.service";
import {StatoEnum} from "../../../_models/generated/stato-enum";

@Component({
  selector: 'app-spedizione-input',
  templateUrl: './spedizione-input.component.html',
  styleUrls: ['./spedizione-input.component.scss'],
  standalone: false
})
export class SpedizioneInputComponent implements OnInit {
  @Input() contesto = -1;
  @Input() codCliFor = -1;
  @Input() stato = -1;
  @Input() idDocumento: number;
  @Input() idRiga: number;
  @Input() idRigaLavorazione: number;
  @Input() idRisorsa = 0;
  @Input() showCreate = false;
  @Input() generaOnInit = false;
  @Input() rifSpe = '';
  @Output() rifSpeChange = new EventEmitter<string>();
  @Output() spedizioneChange = new EventEmitter<Spedizione>();
  spedizioni: Spedizione[] = [];
  startDate = new Date(2000, 0, 1, 0, 0, 0).toISOString();
  endDate = new Date(2099, 11, 31, 1, 0, 0).toISOString();
  showSpedizione = false;
  loading = false;

  constructor(
    private organizzazioneService: OrganizzazioniService,
    private authService: AuthenticationService,
    private spedizioneService: SpedizioniService,
    private saveMessage: SaveMessage) { }

  ngOnInit() {
    if (this.generaOnInit) {
      const now = new Date();
      const yy = String(now.getFullYear()).slice(-2);
      const MM = String(now.getMonth() + 1).padStart(2, '0');
      const dd = String(now.getDate()).padStart(2, '0');
      const HH = String(now.getHours()).padStart(2, '0');
      const mm = String(now.getMinutes()).padStart(2, '0');
      this.createSpedizione(`${yy}${MM}${dd}${HH}${mm}_`);
    }
  }

  searchSpedizioni(fromInput: boolean) {
    this.showSpedizione = fromInput ? true : !this.showSpedizione;
    if (!this.showSpedizione) {
      this.spedizioni = [];
      return false;
    }
    this.loading = true;
    this.spedizioni = [];
    this.spedizioneService
      .getSpedizioni(this.organizzazioneService.organizzazioneId, '', 0, 0,
        'dataDocumento', true, this.contesto, this.codCliFor, this.rifSpe, this.stato,
        new Date(this.startDate), new Date(this.endDate))
      .then((_spedizione: SearchResult<Spedizione>) => {
        if ((fromInput && _spedizione.totalCount > 1) || (!fromInput && _spedizione.totalCount > 0)) {
          this.spedizioni = _spedizione.result;
        } else if (fromInput && _spedizione.totalCount === 1) {
          this.showSpedizione = false;
          this.rifSpeChange.emit(_spedizione.result[0].rifDocEsterno);
          this.spedizioneChange.emit(_spedizione.result[0]);
        } else if (fromInput) {
          this.rifSpeChange.emit(this.rifSpe);
          this.spedizioneChange.emit(null);
        }
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento delle spedizioni."))
      .finally(() => this.loading = false);
  }

  selectSpedizione = (spedizione: Spedizione) => {
    if (!spedizione || !spedizione.rifDocEsterno) {
      return false;
    }
    this.showSpedizione = false;
    this.spedizioni = [];
    this.rifSpe = spedizione.rifDocEsterno;
    this.spedizioneChange.emit(spedizione);
  };

  createSpedizione = (prefix: string) => {
    this.loading = true;
    const spedizione: Spedizione = {
      organizzazioneId: this.organizzazioneService.organizzazioneId,
      idSpedizione: 0,
      idAnagrafica: this.codCliFor,
      dataUnixRegistrazione: 0,
      dataDocumento: new Date(),
      executedBy: this.authService.currentUserValue.userName,
      rifDocEsterno: this.rifSpe,
      contesto: this.contesto,
      idRisorsa: this.idRisorsa,
      idDocumento: this.idDocumento,
      idRiga: this.idRiga,
      idRigaLavorazione: this.idRigaLavorazione,
      stato: StatoEnum.DA_PIANIFICARE,
      prefixRifDocEsterno: prefix
    };
    this.spedizioneService.createSpedizione(spedizione)
      .then((_spedizione: Spedizione) => {
        this.selectSpedizione(_spedizione);
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con la creazione della spedizione."))
      .finally(() => this.loading = false);
  }
}
